import { useAppSelector } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { productAdderSelectedProduct } from '@src/features/product';

export const useSelectedProductId = () => {
  const widgetId = useWidgetId();
  const productId = useAppSelector(productAdderSelectedProduct(widgetId));

  return productId;
};

export default useSelectedProductId;
